import { useIntl } from "react-intl";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useIsSampleSearchNew from "../../common/sample-search/useIsSampleSearchNew.ts";
import useUserPreference from "../../actions/user/useUserPreference.ts";
import MiscellaneousAiStar from "../../../../common/icons/MiscellaneousAiStar.tsx";
import MiscellaneousSearch from "../../../../common/icons/MiscellaneousSearch.tsx";
import styles from "./NewSampleSearchBanner.module.scss";
import OnboardingBanner from "../../common/onboarding-banner/OnboardingBanner.tsx";

export default function NewSampleSearchBanner() {
  const intl = useIntl();
  const isSampleSearchNew = useIsSampleSearchNew();
  const [hasBeenSeen] = useUserPreference<boolean>(
    UserPreferenceKey.DashboardSamplesSearchBannerDismissed
  );

  if (!isSampleSearchNew || hasBeenSeen) {
    return null;
  }

  return (
    <OnboardingBanner
      theme="accent"
      leftContent={
        <div className={styles.artWrapper}>
          <MiscellaneousAiStar className={styles.star1} />
          <MiscellaneousAiStar className={styles.star2} />
          <MiscellaneousAiStar className={styles.star3} />
          <div className={styles.sampleSearchBannerCircle}>
            <MiscellaneousSearch className={styles.searchIcon} />
          </div>
        </div>
      }
      badgeText={intl.formatMessage({
        defaultMessage: "New Feature",
      })}
      noMargin
      title={intl.formatMessage({
        defaultMessage: "We’ve Added Almost 1 Million Free eBook Samples!",
      })}
      body={intl.formatMessage({
        defaultMessage:
          "Thinking of a new adoption? Instructors can now browse available eBook samples, evaluate them for course fit, and add them to My Library for instant access to the free eBook sample.",
      })}
      linkText={intl.formatMessage({ defaultMessage: "Browse" })}
      to="/search"
      dismissOnClick={true}
      bannerSeenPreferenceKey={
        UserPreferenceKey.DashboardSamplesSearchBannerDismissed
      }
    />
  );
}
